import React from 'react'

export default class DataSourcePresenterGuidelines extends React.Component {
  constructor(props) {
    super(props);
  };

  render() {
    return(
      <div className="panel panel-default"> 
        <div className="panel-body">
          <h3 className="panel-heading-text" style={{ borderBottom: '1px solid #DFDFDF', paddingBottom: 20, marginTop: 5, marginBottom: 15 }}>{I18n.t('data_source_guidelines')}</h3>
          <div className="container row">
            <div className="col-md-3">
              <label>{I18n.t('system_data')}</label>
              <div>{this.props.data_source.system_data.toString().toLowerCase().replace(/_/g, " ").split(' ').map((s) => s.charAt(0).toUpperCase() + s.substring(1)).join(' ')}</div>
            </div>
            <div className="col-md-3"><label>{I18n.t('chart_types')}:</label>
              <ul style={{listStyleType: 'none', paddingLeft: '0px'}}>{this.props.data_source.chart_types.map(type => <li key={type.id}>{I18n.t(type.name)}</li>)}</ul></div>
            <div className="col-md-3"><label>{I18n.t('primary_columns')}:</label>
              <ul style={{ listStyleType: 'none', paddingLeft: '0px' }}>{this.renderPrimaryColumns()}</ul></div>
          </div>
        </div>
      </div>
    );
  };

  renderPrimaryColumns(){
    var columns = this.props.data_source.primary_columns.split('|')
    return columns.map(column => <li key={column}>{I18n.t(column)}</li>)
  };
};